import type { PropertyDocumentKind, UploadPropertyFileRequest } from '@/shared/api';
import { guessInvoice } from './akteUploadDefaults';

/** Kinds die einen IssuedOn brauchen (Backend PropertyFilePathBuilder.RequiresIssuedOn). */
const KIND_NEEDS_ISSUED: PropertyDocumentKind[] = [
  'Rechnung',
  'Abrechnung',
  'SteuerLaufend',
  'WartungReparatur',
];

const KIND_NEEDS_AMOUNT: PropertyDocumentKind[] = [
  'Rechnung',
  'Abrechnung',
  'WartungReparatur',
  'Garantie',
];

export function kindNeedsIssued(kind: PropertyDocumentKind): boolean {
  return KIND_NEEDS_ISSUED.includes(kind);
}
export function kindNeedsAmount(kind: PropertyDocumentKind): boolean {
  return KIND_NEEDS_AMOUNT.includes(kind);
}

/** User-waehlbare Kinds, gruppiert fuer das Select. AusgangsRechnung ist system-only. */
export const KIND_GROUPS: Array<{ label: string; kinds: PropertyDocumentKind[] }> = [
  { label: 'Stammakte', kinds: ['Stammakte'] },
  { label: 'Belege', kinds: ['Rechnung', 'Abrechnung', 'WartungReparatur'] },
  { label: 'Steuer / Behörde', kinds: ['SteuerLaufend', 'BehoerdeStamm'] },
  { label: 'Inventar', kinds: ['InventarListe', 'Garantie', 'Bedienungsanleitung'] },
  { label: 'Fotos', kinds: ['FotoMarketing', 'FotoZustand', 'FotoInventar', 'FotoSchaden'] },
  { label: 'Zugang', kinds: ['SchluesselZugang'] },
  { label: 'Sonstiges', kinds: ['Sonstiges'] },
];

export interface FileUploadRow {
  id: string;
  file: File;
  kind: PropertyDocumentKind;
  counterparty: string;
  amount: string;
  currency: string;
  issuedOn: string;
  status: 'idle' | 'uploading' | 'done' | 'error';
  error: string | null;
}

export function newFileRow(
  file: File,
  defaultKind: PropertyDocumentKind,
  defaultCurrency: string,
): FileUploadRow {
  const guess = guessInvoice(file.name);
  return {
    id: `${file.name}-${file.size}-${file.lastModified}`,
    file,
    kind: defaultKind,
    counterparty: guess.supplier,
    amount: '',
    currency: defaultCurrency,
    issuedOn: guess.issuedOn,
    status: 'idle',
    error: null,
  };
}

export function isFileRowValid(row: FileUploadRow): boolean {
  return !kindNeedsIssued(row.kind) || row.issuedOn !== '';
}

export function toUploadRequest(row: FileUploadRow): UploadPropertyFileRequest {
  const amount = row.amount.trim() ? Number(row.amount.replaceAll(',', '.')) : null;
  return {
    kind: row.kind,
    counterparty: row.counterparty.trim() || null,
    amount,
    currency: amount !== null ? row.currency || 'EUR' : null,
    issuedOn: row.issuedOn || null,
    validFrom: null,
    validTo: null,
    description: null,
    relatedFileId: null,
  };
}
